// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"aa852305","361":"0c85c0e9","468":"dd02bc27","642":"293a4f23","699":"23b4de67"}[chunkId] + ".chunk.js";
};